/* eslint-disable import/no-named-as-default */
import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import { SimpleLoadingComponent } from '../../utils/apollo';
import UpgradeFormComponent from './upgrade-form';

const query = gql`
  query UpgradeFormComponent {
    viewer {
      id
      firstName
      lastName
      uuid
      email
      enabledFeatures
      institution {
        id
        name
        field_country
        field_state_short_name
      }
    }
  }
`;

export default SimpleLoadingComponent(graphql(query))(UpgradeFormComponent);
